export const environment = {
  production: false,
  apiUrl: 'https://webapi.qa.atlas.adainfrastructure.com',
  apiDatacentersUrl: 'https://webapi.qa.atlas.adainfrastructure.com/datacenters',
  apiUsersUrl: 'https://webapi.qa.atlas.adainfrastructure.com/users/api/v1',
  cognitoDomain: 'https://glpmapbox.auth.us-west-1.amazoncognito.com',
  cognitoClientId: 'e5qne7sk0ahn37dnuhdjums4p',
  cognitoUserPoolId: 'us-west-1_dgicO8k7k',
  envUrl:'https://qa.atlas.adainfrastructure.com',
  auditUrl: 'https://webapi.qa.atlas.adainfrastructure.com/audit/api/v1',
  mapboxToken: 'pk.eyJ1IjoiYWRhaW5mcmEtZ2NoZW4iLCJhIjoiY2xza3Q1OGUwMDIyZjJqcm5xZG1qZ2N2bCJ9.Vu4pJtpk2IRamufU5-P6QQ'
};
